var _line, _line2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.43281,
    y1: 7.67461,
    x2: 13.5675,
    y2: 7.67461,
    stroke: "#F4600C",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1164,
    y1: 11.0418,
    x2: 13.5675,
    y2: 11.0418,
    stroke: "#F4600C",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39283 4.39283C4.58228 4.20338 4.83923 4.09695 5.10716 4.09695H16.8929C17.1609 4.09695 17.4178 4.20338 17.6073 4.39283C17.7967 4.58228 17.9031 4.83923 17.9031 5.10716V10.3266C17.9031 10.6985 18.2047 11 18.5766 11C18.9486 11 19.2501 10.6985 19.2501 10.3266V5.10716C19.2501 4.482 19.0017 3.88245 18.5597 3.44039C18.1176 2.99834 17.5181 2.75 16.8929 2.75H5.10716C4.482 2.75 3.88245 2.99834 3.44039 3.44039C2.99834 3.88245 2.75 4.482 2.75 5.10716V18.5766C2.75 18.849 2.91409 19.0946 3.16575 19.1988C3.41741 19.3031 3.70708 19.2454 3.89969 19.0528L7.0698 15.8827H16.8929C17.5181 15.8827 18.1176 15.6344 18.5597 15.1923C19.0017 14.7503 19.2501 14.1507 19.2501 13.5256V13.3572C19.2501 12.9853 18.9486 12.6837 18.5766 12.6837C18.2047 12.6837 17.9031 12.9853 17.9031 13.3572V13.5256C17.9031 13.7935 17.7967 14.0504 17.6073 14.2399C17.4178 14.4293 17.1609 14.5358 16.8929 14.5358H6.79084C6.61222 14.5358 6.44092 14.6067 6.31462 14.733L4.09695 16.9507V5.10716C4.09695 4.83923 4.20338 4.58228 4.39283 4.39283Z",
    fill: "#F4600C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareMsg);
export default __webpack_public_path__ + "static/media/square-msg.6c43504646792433fc7e90fff47b2136.svg";
export { ForwardRef as ReactComponent };